import { ReactElement } from "react";
import downloadIcon from "assets/images/cloud-download.png";

export function DownloadButton(props: {
  label: string;
  text: string;
  width: string;
  onClick: React.MouseEventHandler;
}): ReactElement {
  const { label, text, width, onClick } = props;

  return (
    <button
      className={`flex flex-row px-2 py-1 space-x-1 items-center justify-start text-blue-400 hover:text-white font-bold border-2 border-blue-400 hover:bg-blue-400 ${width}`}
      onClick={onClick}
    >
      <div className="flex flex-col">
        <span className="text-xs">{label}</span>
        <img className="cursor-pointer" src={downloadIcon} alt="Export" />
      </div>
      <span className="text-sm">{text}</span>
    </button>
  );
}
